export function hasAcceptedOffer(transport: { offer_status?: string; request_status: string }): boolean {
  return transport.offer_status === 'accepted'
    && ['matched', 'in_progress', 'completed'].includes(transport.request_status);
}
